<template>
  <div v-if="isSvgPath" class="wd-svg-icon wd-flex wd-items-center wd-justify-center wd-transition-opacity wd-min-w-6">
    <component :is="asset" :class="props.activeClass" class="!wd-max-w-full"></component>
  </div>
  <v-img v-else :class="props.activeClass" :max-width="props.maxWidth" :width="props.width" :height="props.height" cover :src="asset" />
</template>

<script setup lang="ts">
import type { ClassValue } from 'vuetify/lib/composables/component.mjs'

interface Props {
  activeClass?: ClassValue
  imagePath?: string
  maxWidth?: string | number
  width?: string | number
  height?: string | number
  raw?: boolean
}

defineOptions({
  name: 'FunnowIcon',
})

const props = withDefaults(defineProps<Props>(), {
  activeClass: '',
  imagePath: '',
  maxWidth: '',
  width: '',
  height: '',
  raw: false,
})

const assetsPath = computed(() => (props.raw ? props.imagePath : `/images/icon/${props.imagePath}`))
const asset = useAsset<string>(assetsPath)
const isSvgPath = computed(() => assetsPath.value.includes('.svg'))
</script>
